module.exports = __webpack_public_path__ + "img/kg.75b3d9c5.jpg";